import React from 'react';
import './styles/header.scss';
import { RxHamburgerMenu } from 'react-icons/rx';
import { RiUser3Line } from 'react-icons/ri';
import { IoBagHandleOutline } from 'react-icons/io5';
import { MdFavoriteBorder } from 'react-icons/md';
import { LuSearch } from 'react-icons/lu';

function Header() {
    return (
        <header>
            <aside>
                <nav>
                    <RxHamburgerMenu className='menu' />
                </nav>
                <ul>
                    <li>Shop</li>
                    <li>Services</li>
                    <li>Sales</li>
                    <li>Shipping</li>
                    <li>Contacts</li>
                </ul>
            </aside>

            <a className='header-logo' href='/'>
                m<span>y</span>home
            </a>
            <aside>
                <p>+375 29 364-74-69</p>
                <div className='icons'>
                    <LuSearch className='icon' />
                    <RiUser3Line className='icon' />
                    <MdFavoriteBorder className='icon fav_icon' />
                    <IoBagHandleOutline className='icon' />
                </div>
            </aside>
        </header>
    );
}

export default Header;
